export enum GlobalOptions {
    MAX_VISIBLE_MATERIAL_DROPDOWN_ITEMS = 4,
    FILTERS_VERSION = '15',
    ALL = 'all',
    DEFAULT_PRICELIST_VERSION = '-26',
    HEIGHT_PID = 'p7403',
    FINAL_HEIGHT_PID = 'p740650',
    WIDTH_PID = 'p7402',
    FINAL_WIDTH_PID = 'p740649',
    QUANTITY_PID = 'p7404',
    POSITION_PID = 'p7408',
    PRICELIST_PID = 'p7407',
    SISTEM_PID = 'p7405',
    SYSTEM_COLOR_PID = 'p74018',
    MANUAL_REGISTRATION_VID = 'ROČNI VPIS',
    FRAME_WIDTH_PID = 'p740664',
    FRAME_HEIGHT_PID = 'p740665',
    WIDTH_SASH_PID = 'p740666',
    DRIVE_PID = 'p5543',
    LEFT_GUIDE_PID = 'p10468',
    RIGHT_GUIDE_PID = 'p10469',
    ALTERNATIVE_LEFT_GUIDE_PID = 'p40117',
    ALTERNATIVE_RIGHT_GUIDE_PID = 'p40118',
    TOTAL_WIDTH_PID = 'p10302',
    ASSEMBLY_POSITION_PID = 'p40146',
    COMBINATION_TYPE_PID = 'p32678',
    NUMBER_OF_COMBINATIONS_PID = 'p40145',
    COMBINATIONS_PID = 'p10301',
    HERO_COMBINATIONS_PID = 'p40143',
    COMBINED_ASSEMBLY_PID = 'p41831',
    FLOOR_MOUNTING_HERO_PID = 'p40605',
    LEFT_GUIDE_HOLDER_PID = 'p41832',
    RIGHT_GUIDE_HOLDER_PID = 'p41833',
    HERO_TOTAL_WIDTH_PID = 'p40144',
    ROLLER_SHUTTER_BOX_SIZE_PID = 'p40177',
    SELECTED_ROLLER_SHUTTER_BOX_SIZE_PID = 'p111592',
    CONSOLE_SIZE_PID = 'p5552',
    SELECTED_CONSOLE_SIZE_PID = 'p55590',
    CONSOLE_TYPE_PID = 'p5553',
    ROLLER_SHUTTER_BOX_DEPTH_PID = 'p10363',
    ROLLER_SHUTTER_BOX_HEIGHT_PID = 'p10364',
    HERO_MASK_TYPE_PID = 'p9083',
    HERO_GUIDE_LINING_PID = 'p40147',
    HERO_GUIDE_CARRIER_PID = 'p40602',
    DIMENSIONS_TYPE_PID = 'p740593',
    JOINTS_SWITCH_PID = 'p9078',
    JOINTS_POSITION_PID = 'p91759',
    HERO_BOTTOM_CORNER_COVER_PID = 'p9079',
    HERO_CLOSING_PLATE_PID = 'p9080',
    JOINTS_HERO_GUIDE_TYPE_PID = 'p40116',
    JOINTS_HERO_LEFT_GUIDE_PID = 'p40117',
    JOINTS_HERO_RIGHT_GUIDE_PID = 'p40118',
    JOINTS_HERO_NO_GUIDES_SWITCH_PID = 'p40124',
    JOINTS_OLIMP_GUIDE_TYPE_PID = 'p740430',
    OLIMP_JOINTS_SWITCH_PID = 'p740433',
}

export const MANDATORY_SIMPLE_PRODUCT_CATEGORIES = ['INSECT_SCREENS'];
export const COMMON_FIELD_PIDS = [
    GlobalOptions.QUANTITY_PID,
    GlobalOptions.WIDTH_PID,
    GlobalOptions.HEIGHT_PID,
    GlobalOptions.POSITION_PID,
    GlobalOptions.SISTEM_PID,
] as string[];

export const PASTED_FIELD_PIDS = [
    GlobalOptions.QUANTITY_PID,
    GlobalOptions.WIDTH_PID,
    GlobalOptions.HEIGHT_PID,
    GlobalOptions.POSITION_PID,
] as string[];

export const ALTERNATIVE_PASTED_FIELD_PIDS = [
    GlobalOptions.QUANTITY_PID,
    GlobalOptions.POSITION_PID,
    GlobalOptions.FRAME_WIDTH_PID,
    GlobalOptions.FRAME_HEIGHT_PID,
] as string[];

export const CombinationsOptions = {
    SISTEM_PID: GlobalOptions.SISTEM_PID,
    QUANTITY_PID: GlobalOptions.QUANTITY_PID,
    WIDTH_PID: GlobalOptions.WIDTH_PID,
    HEIGHT_PID: GlobalOptions.HEIGHT_PID,
    POSITION_PID: GlobalOptions.POSITION_PID,
    DRIVE_PID: GlobalOptions.DRIVE_PID,
    LEFT_GUIDE_PID: GlobalOptions.LEFT_GUIDE_PID,
    RIGHT_GUIDE_PID: GlobalOptions.RIGHT_GUIDE_PID,
    TOTAL_WIDTH_PID: GlobalOptions.TOTAL_WIDTH_PID,
    ASSEMBLY_POSITION_PID: GlobalOptions.ASSEMBLY_POSITION_PID,
    COMBINATION_TYPE_PID: GlobalOptions.COMBINATION_TYPE_PID,
    NUMBER_OF_COMBINATIONS_PID: GlobalOptions.NUMBER_OF_COMBINATIONS_PID,
    COMBINATIONS_PID: GlobalOptions.COMBINATIONS_PID,
    COMBINED_ASSEMBLY_PID: GlobalOptions.COMBINED_ASSEMBLY_PID,
    FLOOR_MOUNTING_HERO_PID: GlobalOptions.FLOOR_MOUNTING_HERO_PID,
    RIGHT_GUIDE_HOLDER_PID: GlobalOptions.RIGHT_GUIDE_HOLDER_PID,
    LEFT_GUIDE_HOLDER_PID: GlobalOptions.LEFT_GUIDE_HOLDER_PID,
    ROLLER_SHUTTER_BOX_SIZE_PID: GlobalOptions.ROLLER_SHUTTER_BOX_SIZE_PID,
    SELECTED_ROLLER_SHUTTER_BOX_SIZE_PID: GlobalOptions.SELECTED_ROLLER_SHUTTER_BOX_SIZE_PID,
    CONSOLE_SIZE_PID: GlobalOptions.CONSOLE_SIZE_PID,
    SELECTED_CONSOLE_SIZE_PID: GlobalOptions.SELECTED_CONSOLE_SIZE_PID,
    ROLLER_SHUTTER_BOX_DEPTH_PID: GlobalOptions.ROLLER_SHUTTER_BOX_DEPTH_PID,
    ROLLER_SHUTTER_BOX_HEIGHT_PID: GlobalOptions.ROLLER_SHUTTER_BOX_HEIGHT_PID,
    HERO_MASK_TYPE_PID: GlobalOptions.HERO_MASK_TYPE_PID,
    HERO_GUIDE_LINING_PID: GlobalOptions.HERO_GUIDE_LINING_PID,
    HERO_GUIDE_CARRIER_PID: GlobalOptions.HERO_GUIDE_CARRIER_PID,
    DIMENSIONS_TYPE_PID: GlobalOptions.DIMENSIONS_TYPE_PID,
    FINAL_WIDTH_PID: GlobalOptions.FINAL_WIDTH_PID,
    CONSOLE_TYPE_PID: GlobalOptions.CONSOLE_TYPE_PID,
    HERO_GUIDE_TYPE_PID: GlobalOptions.JOINTS_HERO_GUIDE_TYPE_PID,
    HERO_LEFT_GUIDE_TYPE_PID: GlobalOptions.JOINTS_HERO_LEFT_GUIDE_PID,
    HERO_RIGHT_GUIDE_TYPE_PID: GlobalOptions.JOINTS_HERO_RIGHT_GUIDE_PID,
};

export const JOINTS_OPTIONS = {
    SISTEM_PID: GlobalOptions.SISTEM_PID,
    QUANTITY_PID: GlobalOptions.QUANTITY_PID,
    WIDTH_PID: GlobalOptions.WIDTH_PID,
    HEIGHT_PID: GlobalOptions.HEIGHT_PID,
    POSITION_PID: GlobalOptions.POSITION_PID,
    JOINTS_SWITCH_PID: GlobalOptions.JOINTS_SWITCH_PID,
    JOINTS_POSITION_PID: GlobalOptions.JOINTS_POSITION_PID,
    HERO_BOTTOM_CORNER_COVER_PID: GlobalOptions.HERO_BOTTOM_CORNER_COVER_PID,
    HERO_CLOSING_PLATE_PID: GlobalOptions.HERO_CLOSING_PLATE_PID,
    HERO_GUIDE_TYPE_PID: GlobalOptions.JOINTS_HERO_GUIDE_TYPE_PID,
    HERO_LEFT_GUIDE_PID: GlobalOptions.JOINTS_HERO_LEFT_GUIDE_PID,
    HERO_RIGHT_GUIDE_PID: GlobalOptions.JOINTS_HERO_RIGHT_GUIDE_PID,
    HERO_NO_GUIDES_SWITCH_PID: GlobalOptions.JOINTS_HERO_NO_GUIDES_SWITCH_PID,
    OLIMP_GUIDE_TYPE_PID: GlobalOptions.JOINTS_OLIMP_GUIDE_TYPE_PID,
    OLIMP_JOINTS_SWITCH_PID: GlobalOptions.OLIMP_JOINTS_SWITCH_PID,
    ROLLER_SHUTTER_BOX_SIZE_PID: GlobalOptions.ROLLER_SHUTTER_BOX_SIZE_PID,
    SELECTED_ROLLER_SHUTTER_BOX_SIZE_PID: GlobalOptions.SELECTED_ROLLER_SHUTTER_BOX_SIZE_PID,
    ROLLER_SHUTTER_BOX_DEPTH_PID: GlobalOptions.ROLLER_SHUTTER_BOX_DEPTH_PID,
    ROLLER_SHUTTER_BOX_HEIGHT_PID: GlobalOptions.ROLLER_SHUTTER_BOX_HEIGHT_PID,
    CONSOLE_SIZE_PID: GlobalOptions.CONSOLE_SIZE_PID,
    SELECTED_CONSOLE_SIZE_PID: GlobalOptions.SELECTED_CONSOLE_SIZE_PID,
    CONSOLE_TYPE_PID: GlobalOptions.CONSOLE_TYPE_PID,
};
